import { ScopeOverviewResponse } from '@ydistri/api-sdk';

export type ScopeCatalogSortField = 'LastUpdatedAt' | 'Name';

interface GetDisplayedScopesOptions {
  search: string;
  showArchivedItems: boolean;
  showLocalItems: boolean;
  sortField: ScopeCatalogSortField;
}

export const getDisplayedScopes = (
  scopes: ReadonlyArray<ScopeOverviewResponse>,
  { search, showArchivedItems, showLocalItems, sortField }: GetDisplayedScopesOptions,
): ScopeOverviewResponse[] => {
  const normalizedSearch = search.trim().toLocaleLowerCase();
  const sorter =
    sortField === 'Name'
      ? (left: ScopeOverviewResponse, right: ScopeOverviewResponse) =>
          left.name.localeCompare(right.name)
      : (left: ScopeOverviewResponse, right: ScopeOverviewResponse) =>
          right.updatedAt.localeCompare(left.updatedAt);

  return scopes
    .filter(scope => showLocalItems || scope.isShared)
    .filter(scope => showArchivedItems || !scope.isArchived)
    .filter(scope => !normalizedSearch || scope.name.toLocaleLowerCase().includes(normalizedSearch))
    .sort((left, right) => {
      if (left.isArchived !== right.isArchived) return left.isArchived ? 1 : -1;
      return sorter(left, right);
    });
};
